import React, { Component } from "react";
import Konva from "konva";
import { Stage, Line, Layer, Rect } from "react-konva";
import ContextMenu from "./ContextMenu";
import Portal from "./Portal";
import { AlphaPicker, SketchPicker } from "react-color";
import InputRange from "react-input-range";
import "react-input-range/lib/css/index.css";
var color = Konva.Util.getRandomColor();

function downloadURI(uri, name) {
  var link = window.document.createElement("a");
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  //delete link;
}

var slider = document.getElementById("slider");

class LineShapes extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      color: "green",
      bgColor: "dark",
      selectedContextMenu: null,
      numberOfEl: 100,
      numPoints:5,
      innerRadius:20,
      outerRadius:50,
      opacity: 0.5,
      textValue: null,
      fontColor: {
        r: 255,
        g: 255,
        b: 255,
        a: 0.7
      },
      rectBackground: {
        r: 0,
        g: 0,
        b: 0,
        a: 0.7
      }
    };
    this.handleDbleClick = this.handleDbleClick.bind(this);
    this.downloadURI = this.downloadURI.bind(this);
    this.handleContextMenu = this.handleContextMenu.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDbleClick = this.handleDbleClick.bind(this);
    this.handleNumberOfElChange = this.handleNumberOfElChange.bind(this);
    this.handlenumPointsChange = this.handlenumPointsChange.bind(this);
    this.handleinnerRadiusChange = this.handleinnerRadiusChange.bind(this);
    this.handleouterRadiusChange = this.handleouterRadiusChange.bind(this);
    this.handleRectColorChange = this.handleRectColorChange.bind(this);
    this.handleRectOpacityChange = this.handleRectOpacityChange.bind(this);
    this.handleOpacityChange = this.handleOpacityChange.bind(this);
  }
  handleOptionSelected = option => {
    console.log(option);
    this.setState({
      selectedContextMenu: null
    });
  };

  handleContextMenu = e => {
    e.evt.preventDefault(true); // NB!!!! Remember the ***TRUE***
    const mousePosition = e.target.getStage().getPointerPosition();

    this.setState({
      selectedContextMenu: {
        type: "START",
        position: mousePosition
      }
    });
  };
  handleDragStart = e => {
    e.target.setAttrs({
      shadowOffset: {
        x: 15,
        y: 15
      },
      scaleX: 1.1,
      scaleY: 1.1
    });
  };
  handleDragEnd = e => {
    e.target.to({
      duration: 0.5,
      easing: Konva.Easings.ElasticEaseOut,
      scaleX: 1,
      scaleY: 1,
      shadowOffsetX: 5,
      shadowOffsetY: 5
    });
  };

  handleDbleClick() {
    this.setState({
      color: Konva.Util.getRandomColor(),
      bgcolor: Konva.Util.getRandomColor()
    });
  }

  downloadURI(uri, name) {
    console.log(uri);
    this.downloadLinkNode.download = name;
    this.downloadLinkNode.href = uri;
    this.downloadLinkNode.click();
  }

  handleChange = e => {
    this.setState({
      textValue: e.target.value
    });
  };

  handleNumberOfElChange = value => {
    this.setState({
      numberOfEl: value
    });
  };

  handleinnerRadiusChange = value => {
    this.setState({
      innerRadius: value
    });
  };
  handleouterRadiusChange = value => {
    this.setState({
      outerRadius: value
    });
  };


  handlenumPointsChange = value => {
    this.setState({
      numPoints: value
    });
  };
  handleRectColorChange = color => {
    this.setState({
      fontColor: color.rgb
    });
  };

  handleRectOpacityChange = color => {
    let oldColor = this.state.rectBackground;
    this.setState({
      rectBackground: { ...oldColor, a: color.rgb.a }
    });
  };

  handleOpacityChange = color => {
    this.setState({
      opacity: color
    });
  };
  hide = () => {
    const mystar = document.getElementById("mystar");
    const star = document.getElementsByName("star");
    star.AddEventsListener(
      "Click",
      function() {
        mystar.hide();
        console.log(mystar);
        console.log(star);
      },
      false
    );
  };
  /*newPattern(){
  const stage1=document.getElementById('stage1');

   stage1.clear(stage1);
  
  var stage = new Konva.Stage({
  
    width:window.innerWidth/2 +200,
    height:window.innerHeight/2 +100,
    container: 'fiber' // or "#containerId" or ".containerClass"
  });

  var layer = new Konva.Layer();
  stage.add(layer);
  
  // add default shape
  var star = new Konva.Star({
    x: 100,
    y: 200,
    numPoints: 5,
    innerRadius: 70,
    outerRadius: 70,
    fill: 'red',
    stroke: 'black',
    strokeWidth: 4
  });
  layer.add(star);

  layer.draw();

}*/

  render() {
    const { selectedContextMenu } = this.state;
    const { numberOfEl,numPoints,innerRadius,outerRadius } = this.state;
    const { textValue, opacity, rectBackground, fontColor } = this.state;
    return (
      <div className="container-fluid d-flex justify-content-center  ">
        <div id="canvas-konva" className="canvas">
        <Stage
          id="container"
          width={window.innerWidth / 2 }
          height={window.innerHeight / 2 }
          
          ref={node => {
            this.stageNode = node;
          }}
        >
         

          <Layer id="background">
            <Rect
             width={window.innerWidth / 2 }
            height={window.innerHeight / 2 }
              fill={Konva.Util.getRandomColor()}
              opacity={0.8}
            />
          </Layer>

          <Layer id="layer1">
            {[...Array(numberOfEl)].map((_, i) => (
              <Line
             key={i}
         x={Math.random() * window.innerWidth/2}
          y={Math.random() * window.innerHeight/2}
        points= {[5, 200, 10, 200, 15,200, 20,155]}
        stroke={`rgba(${fontColor.r},${fontColor.g},${fontColor.b}, ${fontColor.a})`}
        strokeWidth= {innerRadius}
        lineCap="round"
        lineJoin="round"

              />
            ))}

          </Layer>
          {selectedContextMenu && (
            <Portal>
              <ContextMenu
                {...selectedContextMenu}
                onOptionSelected={this.handleOptionSelected}
              />
            </Portal>
          )}
        </Stage>
        </div>
       

        <div className="side-menu container-fluid expand-sm col-sm-3 row">
         
            <span className="bg-dark mr-2 text-white" data-toggle="collapse" data-target="#ctrl-menu" id="close">
              <i className="fa fa-angle-double-right" aria-hidden="true"></i>
            </span>
          

          <div id="ctrl-menu" className="collapse">
           <div>
           <span
              className="mr-2"
              type="button"
              onClick={() => {
                const dataURL = this.stageNode.getStage().toDataURL({ pixelRatio: 2 });
                downloadURI(dataURL, "stage1.png");
              }}
            >
              <i
                className="fa fa-download large bg-dark text-white"
                aria-hidden="true"
              ></i>
            </span>
            <a
              ref={node => {
                this.downloadLinkNode = node;
              }}
            />

            <span className="mr-2 disabled" onClick={this.show}>
              <i
                className="fa fa-random large bg-dark text-white"
                aria-hidden="true"
              ></i>{" "}
            </span>
           </div>
           
          
          <br />

          <div>
            <div className="text-center">
              <span>Shape</span>
              <InputRange
                step={2}
                maxValue={600}
                value={this.state.numberOfEl}
                minValue={1}
                onChange={numberOfEl => this.setState({ numberOfEl })}
                onChangeComplete={numberOfEl => console.log(numberOfEl)}
                width={200}
                height={100}
              />
            </div>
            <div className="text-center">
              <span> Points</span>
              <InputRange
                step={1}
                maxValue={200}
                value={this.state.numPoints}
                minValue={1}
                onChange={numPoints => this.setState({ numPoints })}
                onChangeComplete={numPoints => console.log(numPoints)}
                width={200}
                height={100}
              />
            </div>
            <div className="text-center">
              <span>Inner Radius</span>
              <InputRange
                step={1}
                maxValue={500}
                value={this.state.innerRadius}
                minValue={1}
                onChange={innerRadius => this.setState({ innerRadius })}
                onChangeComplete={innerRadius => console.log(innerRadius)}
                width={200}
                height={100}
              />
            </div>
            <div className="text-center">
              <span>Outer Radius</span>
              <InputRange
                step={2}
                maxValue={600}
                value={this.state.outerRadius}
                minValue={1}
                onChange={outerRadius => this.setState({ outerRadius })}
                onChangeComplete={outerRadius => console.log(outerRadius)}
                width={200}
                height={100}
              />
            </div>
            <div className="text-center">
              <span>Color picker</span>

              <SketchPicker
                color={rectBackground}
                onChange={this.handleRectColorChange}
                width={200}
                height={100}
              />
            </div>
            
            <div>
              <AlphaPicker
                color={fontColor}
                height={"10px"}
                minValue={(0, 1)}
                maxValue={1}
                value={opacity}
                onChange={this.handleOpacityChange}
                width={200}
              />
            </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LineShapes;
